import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';

import SelectSMJField from './fields/SelectSMJField';
import { useTranslation } from 'react-i18next';

const SMJConfigField = ({ classes, descriptor, value, onChange, onOperatorChange, validity }) => {
  const { t } = useTranslation();

  switch (descriptor.type) {
    case 'CLUBS':
      return (
        <SelectSMJField
          validity={validity}
          selectAll={options => options.reduce((r, opts) => [...r, ...opts.options], [])}
          getValue={vals => vals}
          value={value || {}}
          classes={classes}
          descriptor={descriptor}
          mapValue={values => values}
          onChange={v => {
            onChange(v, true);
          }}
          onOperatorChange={onOperatorChange}
        />
      );

    case 'DATE':
    case 'FOREIGN_KEY':
    case 'ENUM':
    case 'ENUM_TEXT':
    case 'INTEGER':
    case 'NUMBER':
    case 'TEXT':
    default:
      break;
  }
  return (
    <>
      <div>
        {t('field_type_error', {
          fieldType: descriptor.type,
        })}
      </div>
    </>
  );
};

SMJConfigField.propTypes = {
  classes: PropTypes.object.isRequired,
  descriptor: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onOperatorChange: PropTypes.func.isRequired,
  validity: PropTypes.object.isRequired,
};

SMJConfigField.defaultProps = {};

const styles = () => ({
  fieldContainer: {
    display: 'flex',
  },
});

export default withStyles(SMJConfigField, styles);
